const DISMISSED_KEY = 'dismissed_new_feature';
const LAST_VIEWED_KEY = 'last_viewed_new_features';

export const setLastViewedAt = (timestamp: number): void => {
  try {
    localStorage.setItem(LAST_VIEWED_KEY, String(timestamp));
  } catch (error) {
    console.error('Failed to save last viewed timestamp to localStorage:', error);
  }
};

export const getLastViewedAt = (): number | null => {
  try {
    const value = localStorage.getItem(LAST_VIEWED_KEY);
    return value ? Number(value) : null;
  } catch (error) {
    console.error('Failed to read last viewed timestamp from localStorage:', error);
    return null;
  }
};

/**
 * Check if a feature notification has been dismissed by the user
 */
export const isDismissed = (id: string): boolean => {
  try {
    const dismissed = JSON.parse(localStorage.getItem(DISMISSED_KEY) || '{}');
    return dismissed[id] === true;
  } catch (error) {
    console.error('Failed to read dismissed notifications from localStorage:', error);
    return false;
  }
};

/**
 * Mark a feature notification as dismissed
 */
export const markAsDismissed = (id: string): void => {
  try {
    const dismissed = JSON.parse(localStorage.getItem(DISMISSED_KEY) || '{}');
    dismissed[id] = true;
    localStorage.setItem(DISMISSED_KEY, JSON.stringify(dismissed));
  } catch (error) {
    console.error('Failed to save dismissed notification to localStorage:', error);
  }
};
